import{DELETE_COUPONS_FROM_CART}from"../constants";/**
 * Creates the dispatched DELETE_COUPONS_FROM_CART action object.
 * @param {Array} couponIds The coupon ids.
 * @returns {Object} The dispatched action object.
 */var deleteCouponsFromCart=function deleteCouponsFromCart(couponIds){return{type:DELETE_COUPONS_FROM_CART,couponIds:couponIds};};export default deleteCouponsFromCart;